import React from "react";
import "./NavBar.css";
import logo from "../images/logo.png";
import { Link } from "react-router-dom";

function NavBar() {
  return (
    <div>
      <nav className="navbar navbar-expand-lg navbar-dark NavBarCustom ">
        <div className="logo">
          <a className="navbar-brand" href="/#">
            <img src={logo} width="40" height="40" alt="" />
          </a>
          <a className="navbar-brand" href="/#">
            <strong>ENIRISST</strong>
          </a>
        </div>
        <button
          className="navbar-toggler ml-auto"
          type="button"
          data-toggle="collapse"
          data-target="#navbarTogglerDemo02"
          aria-controls="navbarTogglerDemo02"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div
          className="collapse navbar-collapse ml-auto text-right justify-content-end"
          id="navbarTogglerDemo02"
        >
          <ul className="navbar-nav ml-auto">
            <li className="nav-item">
              <Link className="nav-link" to="/">
                {" "}
                Αρχική{" "}
              </Link>
            </li>
            <li className="nav-item">
              {/* Change here if we need another page to /RoadTransport*/}
              <Link className="nav-link" to="/RoadTransport">
                Απευθείας Σύνδεση{" "}
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/Simulation">
                Σύνδεση με ενδιάμεσο προορισμό
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/OptimalRoute">
                Υπολογισμός βέλτιστης διαδρομής
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  );
}

export default NavBar;
